import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronUp, faChevronDown } from '@fortawesome/pro-regular-svg-icons'

library.add(faChevronUp, faChevronDown);